import { STORAGE_APP_ID, STORAGE_TOKEN } from '../http/http_middleware';
import { LocalStorageWrapper } from './localstorage';

export const storageWrapper = new LocalStorageWrapper();

type StorageCredentials = {
  appId: string | undefined;
  token: string | undefined;
};

export const getStorageCredentials = (): StorageCredentials => ({
  appId: storageWrapper.getItem(STORAGE_APP_ID) ?? undefined,
  token: storageWrapper.getItem(STORAGE_TOKEN) ?? undefined,
});

export function setStorageCredentials(appId: string, token: string) {
  storageWrapper.setItem(STORAGE_APP_ID, appId);
  storageWrapper.setItem(STORAGE_TOKEN, token);
}

export function hasStorageCredentials(): boolean {
  const { appId, token } = getStorageCredentials();
  return Boolean(appId && token);
}

export function clearStorageCredentials() {
  storageWrapper.removeItem(STORAGE_APP_ID);
  storageWrapper.removeItem(STORAGE_TOKEN);
}

/**
 * A share opened by a signed-in user must identify them, or the backend rejects
 * the login with "authentication required" whenever the domain enforces
 * enterprise security. Spread into every share login body so no path can forget it.
 */
export function getShareLoginCredentials():
  | { app_id: string; token: string }
  | undefined {
  const { appId, token } = getStorageCredentials();
  if (!appId || !token) {
    return undefined;
  }
  return { app_id: appId, token };
}
